export default "__VITE_ASSET__BJpt9dRr__"